import { __awaiter, __rest } from "tslib";
export function useShare() {
    return {
        twitterShare,
        facebookShare,
        emailShare,
        nativeShare,
        getUrlFacebook,
        getUrlTwitter
    };
}
function twitterShare(params) {
    window.open(getUrlTwitter(params), '_blank');
}
function facebookShare(href) {
    window.open(getUrlFacebook(href), '_blank');
}
function getUrlTwitter(params) {
    let shareURL = 'https://twitter.com/intent/tweet?';
    for (const prop in params)
        shareURL += '&' + prop + '=' + encodeURIComponent(params[prop]);
    return shareURL;
}
function getUrlFacebook(href) {
    return `https://www.facebook.com/sharer/sharer.php?u=${href}`;
}
function emailShare(params) {
    const { recipient } = params, parameters = __rest(params, ["recipient"]);
    let shareURL = `mailto:${params.recipient}?`;
    for (const prop in parameters)
        shareURL += '&' + prop + '=' + encodeURIComponent(params[prop]);
    window.open(shareURL);
}
function nativeShare(params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield navigator.share(params);
        }
        catch (err) {
            console.log(err);
        }
    });
}
